<!-- 数字版面 -->
<template>
  <div class="newspapers_digital_edition">
    <div class="img_center">
      <img :usemap="'#newspaperMap_' + randomId" alt="图片加载中" :src="imgSrc" />
      <div class="area_list">
        <img :src="imgSrc" />
        <map :name="'newspaperMap_' + randomId" :id="'newspaperMap_' + randomId">
          <area @touchstart="showHighLight(area.layoutCoordinate)" @touchend="hideHighLight" shape="polygon"
            :coords="calcArea(area.layoutCoordinate)" @click="goToDetail(area)" :key="index"
            v-for="(area, index) in areaMapList" />
        </map>
        <div v-show="highLightArea" :style="highLightArea" class="high_light"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "newspapersDigitalEdition",
  props: {
    areaMapList: {
      type: Array,
      required: true,
    },
    imgSrc: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      highLightArea: "",
      randomId: Math.round(Math.random() * 1000000),
      containerWidthHeight: "",
      title: "",
      hideHighLightDelayerTimer: null,
      hideHighLightDelayerTime: 5e2
    };
  },
  mounted() {
    let $container = $(this.$el);
    this.containerWidthHeight = {
      width: $container.width(),
      height: $container.height(),
    };
    this.title = document.title;
    window.addEventListener('blur', this.hideHighLight);
  },
  methods: {
    /**
     * [showHighLight description] 显示高亮
     * @param  {[type]} area [description]
     * @return {[type]}      [description]
     */
    showHighLight(data) {
      let dataArray = [];
      let array = [];
      dataArray = data.split(",");
      for (let i = 0; i < dataArray.length; i += 2) {
        dataArray[i] = dataArray[i];
        dataArray[i + 1] = dataArray[i + 1];
        array.push([dataArray[i], dataArray[i + 1]]);
      }
      for (let i in array) {
        let elem = array[i];
        array[i] = elem[0] + " " + elem[1];
      }
      let clipPath = array.join(",");
      clipPath = `polygon(${clipPath})`;
      this.highLightArea = {
        "-webkit-clip-path": clipPath,
        "clip-path": clipPath,
      };
      clearTimeout(this.hideHighLightDelayerTimer);
      this.hideHighLightDelayerTimer = setTimeout(() => {
        this.hideHighLight();
      }, this.hideHighLightDelayerTime);
    },
    /**
     * [hideHighLight description] 隐藏高亮
     * @return {[type]} [description]
     */
    hideHighLight() {
      this.highLightArea = "";
    },
    /**
     * [goToDetail description]跳转至详情页
     * @param  {[type]} area [description]当前热区
     * @return {[type]}      [description]
     */
    goToDetail(area) {
      let location = this.$router.resolve({
        name: "newspapersDetail",
        query: {
          id: area.layoutDetailId,
          title: this.title,
          pictureDetail: area.pictureDetail,
        },
      });
      let href = window.location.origin + location.href;
      window.CP.openNewPage({
        url: href,
        title: ''
      });
      // window.open(href, '_blank');
      /* let $a = $("<a></a>");
      $a.attr({
        href,
        target: "_blank",
      });
      $a[0].click(); */
    },
  },
  destroyed() {
    clearTimeout(this.hideHighLightDelayerTimer);
    window.removeEventListener('blur', this.hideHighLight);
  },
  computed: {
    calcArea() {
      let self = this;
      return (data) => {
        if (!data) {
          return {};
        }
        let dataArray = [];
        let array = [];
        dataArray = data.split(",");
        if (dataArray[0].indexOf("%") > 0) {
          //如果坐标是百分比，要将其转换为数字
          dataArray = dataArray.map((value, index) => {
            value = Number(value.replace(/%/g, ""));
            if (index % 2 == 0) {
              return (value * self.containerWidthHeight.width) / 100;
            } else {
              return (value * self.containerWidthHeight.height) / 100;
            }
          });
        }
        for (let i = 0; i < dataArray.length; i += 2) {
          dataArray[i] = dataArray[i];
          dataArray[i + 1] = dataArray[i + 1];
          array.push([dataArray[i], dataArray[i + 1]]);
        }
        for (let i in array) {
          let elem = array[i];
          array[i] = elem[0] + "," + elem[1];
        }
        let clipPath = array.join(",");
        return clipPath;
      };
    },
  },
};
</script>
<style lang="less" scoped>
.newspapers_digital_edition {
  text-align: center;
  width: 100%;
  height: 100%;

  .img_center {
    height: 100%;
    position: relative;
    display: inline-block;
    padding: 0 10px;
    box-sizing: border-box;

    &>img {
      height: 100%;
      max-width: 100%;
      object-fit: contain;
      left: 50%;
      position: relative;
      transform: translate(-50%);
      z-index: 1;
      opacity: 0;
    }

    .area_list {
      display: inline-block;
      position: absolute;
      left: 50%;
      top: 0;
      width: calc(100% - 20px);
      height: 100%;
      transform: translate(-50%, 0);
      overflow: hidden;

      img {
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        object-fit: contain;
        max-width: 100%;
      }

      .high_light {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        background: yellow;
        opacity: 0.5;
      }
    }
  }
}
</style>